/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteDtoModel, RouteDtoModelType } from "./RouteDtoModel"
import { RouteDtoModelSelector } from "./RouteDtoModel.base"
import { RouteSolutionViolationDtoModel, RouteSolutionViolationDtoModelType } from "./RouteSolutionViolationDtoModel"
import { RouteSolutionViolationDtoModelSelector } from "./RouteSolutionViolationDtoModel.base"
import { RouteTimelineDtoModel, RouteTimelineDtoModelType } from "./RouteTimelineDtoModel"
import { RouteTimelineDtoModelSelector } from "./RouteTimelineDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  routeTimeline: IObservableArray<RouteTimelineDtoModelType>;
  violations: IObservableArray<RouteSolutionViolationDtoModelType>;
  route: RouteDtoModelType;
}

/**
 * RouteSolutionDtoBase
 * auto generated base class for the model RouteSolutionDtoModel.
 */
export const RouteSolutionDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteSolutionDto')
  .props({
    __typename: types.optional(types.literal("RouteSolutionDto"), "RouteSolutionDto"),
    id: types.identifier,
    routeId: types.union(types.undefined, types.string),
    solutionId: types.union(types.undefined, types.integer),
    drivingTime: types.union(types.undefined, types.integer),
    workingTime: types.union(types.undefined, types.number),
    totalIdleTime: types.union(types.undefined, types.integer),
    load: types.union(types.undefined, types.number),
    distance: types.union(types.undefined, types.integer),
    stopsCount: types.union(types.undefined, types.integer),
    ordersCount: types.union(types.undefined, types.integer),
    active: types.union(types.undefined, types.boolean),
    finished: types.union(types.undefined, types.null, types.boolean),
    createdOn: types.union(types.undefined, types.string),
    publishedOn: types.union(types.undefined, types.null, types.string),
    routeTimeline: types.union(types.undefined, types.array(MSTGQLRef(types.late((): any => RouteTimelineDtoModel)))),
    violations: types.union(types.undefined, types.array(MSTGQLRef(types.late((): any => RouteSolutionViolationDtoModel)))),
    route: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => RouteDtoModel))),
    polyline: types.union(types.undefined, types.null, types.string),
    transportationMode: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteSolutionDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get routeId() { return this.__attr(`routeId`) }
  get solutionId() { return this.__attr(`solutionId`) }
  get drivingTime() { return this.__attr(`drivingTime`) }
  get workingTime() { return this.__attr(`workingTime`) }
  get totalIdleTime() { return this.__attr(`totalIdleTime`) }
  get load() { return this.__attr(`load`) }
  get distance() { return this.__attr(`distance`) }
  get stopsCount() { return this.__attr(`stopsCount`) }
  get ordersCount() { return this.__attr(`ordersCount`) }
  get active() { return this.__attr(`active`) }
  get finished() { return this.__attr(`finished`) }
  get createdOn() { return this.__attr(`createdOn`) }
  get publishedOn() { return this.__attr(`publishedOn`) }
  get polyline() { return this.__attr(`polyline`) }
  get transportationMode() { return this.__attr(`transportationMode`) }
  routeTimeline(builder: string | RouteTimelineDtoModelSelector | ((selector: RouteTimelineDtoModelSelector) => RouteTimelineDtoModelSelector) | undefined) { return this.__child(`routeTimeline`, RouteTimelineDtoModelSelector, builder) }
  violations(builder: string | RouteSolutionViolationDtoModelSelector | ((selector: RouteSolutionViolationDtoModelSelector) => RouteSolutionViolationDtoModelSelector) | undefined) { return this.__child(`violations`, RouteSolutionViolationDtoModelSelector, builder) }
  route(builder: string | RouteDtoModelSelector | ((selector: RouteDtoModelSelector) => RouteDtoModelSelector) | undefined) { return this.__child(`route`, RouteDtoModelSelector, builder) }
}
export function selectFromRouteSolutionDto() {
  return new RouteSolutionDtoModelSelector()
}

export const routeSolutionDtoModelPrimitives = selectFromRouteSolutionDto().routeId.solutionId.drivingTime.workingTime.totalIdleTime.load.distance.stopsCount.ordersCount.active.finished.createdOn.publishedOn.polyline.transportationMode
